import { Navigate, Outlet, useMatches } from 'react-router';

import { ROUTES } from '@/config/routes';
import type { RouteHandle } from '@/hooks/useRouteHandle';
import { useAuthStore } from '@/stores/auth';

/**
 * 워크스페이스 화면 기능 가드 — 매치된 라우트 handle 의 `feature` 가 세션 기능 목록에 없으면 "권한 필요" 안내로 보낸다
 * (specs/064 FR-011, clarify Q3). 기능 키는 각 feature 의 `routes.tsx` handle 이 소유한다(라우트 정의 = 기능 표시의 한 곳).
 * `RequireWorkspaceMember` 안쪽에서만 쓴다. 최종 강제는 서버 기능 허용 인터셉터.
 */
export function RequireRouteFeature() {
  const matches = useMatches();
  const features = useAuthStore((s) => s.features);
  const required = matches
    .map((m) => (m.handle as RouteHandle | undefined)?.feature)
    .filter((f) => f !== undefined);
  if (required.some((f) => !features.includes(f))) {
    return <Navigate to={ROUTES.errorAuthRequired} replace />;
  }
  return <Outlet />;
}
